export default "__VITE_ASSET__Djm03bI7__"